// src/components/actions/actions.js
import { euroFormat } from "../../../utils/usefullFunctions";
import moment from "moment";

// Functie om een veilige facturatielink te maken
export const createSafeFactLink = (project, invoice, user) => {
    const body = "Beste Receptie, \n\n" +
        `Graag voor het project ${project.project_code} ${project.project_name} het termijn ${invoice.projects_invoice_terms_commentary}, ${euroFormat(invoice.projects_invoice_terms_invoice_amount)} factureren.\n`
        + `${user?.name || ""}\n`;

    const subject = `${project.project_code} - ${project.project_name} - ${invoice.projects_invoice_terms_commentary}`;

    return `mailto:sm-nl-admin@nordomatic.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};

export const createSafeMoveLink = (project, invoice, newDate, user) => {
    const twoMonthsFromNow = moment().add(2, 'months');
    const invoiceDate = moment(invoice.projects_invoice_terms_planned_for);

    const newDateMoment = moment(newDate);
    if (!user.isAdmin && newDateMoment.isAfter(twoMonthsFromNow)) {
        return "Error: De factuurdatum kan niet meer dan twee maanden in de toekomst worden verplaatst. Vraag LVH voor uitzondering.";
    }

    const formattedNewDate = newDate ? moment(newDate).format("DD MMMM YYYY") : "geen datum geselecteerd";

    const body = "Beste Receptie, \n\n" +
        `Graag voor het project ${project.project_code} ${project.project_name} het termijn ${invoice.projects_invoice_terms_commentary}, ${euroFormat(invoice.projects_invoice_terms_invoice_amount)} verplaatsen van ${invoiceDate.format("DD MMMM YYYY")} naar ${formattedNewDate} in 365.\n`;

    const subject = `${project.project_code} - ${project.project_name} - ${invoice.projects_invoice_terms_commentary}`;

    return `mailto:sm-nl-admin@nordomatic.com?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
};
